/* eslint-disable react-hooks/exhaustive-deps */
import { Button, InputLabel } from '@mui/material';
import { FormContainer, SubmitWrapper } from "../Hospitals/HospitalStyle"
import React, { useEffect, useLayoutEffect } from 'react'
import {
  chiefdom_options,
  client_is_handicapped_options,
  country_of_origin_options,
  education_level_options,
  ethnicity_options,
  gender_options,
  inkhulda_options,
  marital_status_options,
  occupation_options,
  patient_regions_options
} from './PatientFormOptions';

import CustomApiLoader from '../../components/CustomApiLoader/CustomApiLoader';
import CustomToast from '../../components/Toast/CustomToast';
import DatePickerController from '../../components/CustomDatepicker/CustomDatePicker';
import { ENDPOINT } from '../../services/endPoints';
import InputController from '../../components/InputController/InputController';
import PatientFormSchema from '../../schemas/PatientDetailFormSchema';
import SelectController from '../../components/SelectController/SelectController';
import { useForm } from 'react-hook-form';
import useMasterApi from '../../services/useMasterApi';
import { useNavigate } from 'react-router-dom';
import useToast from '../../hooks/useToast';
import { useUpdateForm } from '../../context/UpdateFormProvider';
import { yupResolver } from '@hookform/resolvers/yup';

const PateintDetailUpdate = () => {
  const { toastMessage, toast, toastType, setToast, showToast } = useToast()
  const { loading: updateLoading, data: updateResponse, error: updateError, put } = useMasterApi()

  const navigate = useNavigate()
  const { updateFormValues } = useUpdateForm()

  if (!updateFormValues) {
    window.history.back(); 
    navigate("/patient-list", { replace: true })
  }

  let {
    id = "",
    patient_first_name = "",
    patient_middle_name = "",
    patient_last_name = "",
    dob = "",
    sex = "",
    ethnicity = "",
    marital_status = "",
    education_level = "",
    occupation = "",
    country_of_origin = "",
    client_is_handicapped = "",
    disability = "",
    permanent_residential_address = "",
    inkhundla = "",
    chiefdom = "",
    current_residential_address = "",
    postal_address = "",
    primary_cellphone = "",
    secondary_cellphone = "",
    land_phone = "",
    patient_email_id = "",
    national_id = "",
    patient_region = "",
    CMIS_id = "",
    patient_code = "",
    question1 = "",
    question2 = "",
    question3 = "",
    nurse_id = "",
    nurse_name = "",
    year = "",
  } = updateFormValues || {};


  const isUpdate = !!Object.keys(updateFormValues || {}).length


  const { handleSubmit, reset, watch, clearErrors,getValues, setValue, setError, control, formState: { errors, isValid } } = useForm({
    resolver: yupResolver( isUpdate ? PatientFormSchema :  null),
    mode: "onChange",
    defaultValues: {
      id: isUpdate ? id : "",
      patient_first_name: isUpdate ? patient_first_name : "",
      patient_middle_name: isUpdate ? patient_middle_name : "",
      patient_last_name: isUpdate ? patient_last_name : "",
      dob: isUpdate ? dob : "",
      sex: isUpdate ? sex : "",
      ethnicity: isUpdate ? ethnicity : "",
      marital_status: isUpdate ? marital_status : "",
      education_level: isUpdate ? education_level : "",
      occupation: isUpdate ? occupation : "",
      country_of_origin: isUpdate ? country_of_origin : "",
      client_is_handicapped: isUpdate ? client_is_handicapped : "",
      disability: isUpdate ? disability : "",
      permanent_residential_address: isUpdate ? permanent_residential_address : "",
      inkhundla: isUpdate ? inkhundla : "",
      chiefdom: isUpdate ? chiefdom : "",
      current_residential_address: isUpdate ? current_residential_address : "",
      postal_address: isUpdate ? postal_address : "",
      primary_cellphone: isUpdate ? primary_cellphone : "",
      secondary_cellphone: isUpdate ? secondary_cellphone : "",
      land_phone: isUpdate ? land_phone : "",
      patient_email_id: isUpdate ? patient_email_id : "",
      national_id: isUpdate ? national_id : "",
      patient_region: isUpdate ? patient_region : "",
      CMIS_id: isUpdate ? CMIS_id : "",
      patient_code: isUpdate ? patient_code : "",
      question1: isUpdate ? question1 : "",
      question2: isUpdate ? question2 : "",
      question3: isUpdate ? question3 : "",
      nurse_id: isUpdate ? nurse_id : "",
      nurse_name: isUpdate ? nurse_name : "",
      year: isUpdate ? year : "",
    }
  });

  const selectedInkhundla = watch("inkhundla");
  const checkChiefdom = Object?.keys(chiefdom_options)?.includes(selectedInkhundla);
  const watchingCheifdom = watch("chiefdom")

  useEffect(()=>{
    if(!checkChiefdom){
      setValue("chiefdom", "none", {shouldValidate: false});
    }
    else if (checkChiefdom && (watchingCheifdom==="" || watchingCheifdom==="none")) {
      setError("chiefdom", {
        type: "manual",
        message: "Chiefdom is required when Inkhundla is Selected",
      });
    }
    else {
      clearErrors("chiefdom");
    }
  }, [checkChiefdom, watchingCheifdom]);

  useEffect(()=>{
    if (selectedInkhundla && isUpdate){
      if (selectedInkhundla!==inkhundla) setValue("chiefdom", "none")
    }
  }, [selectedInkhundla])

  
  const onSubmit = async (data) => {
    if (isUpdate) {
      const formData = { ...data };
      await put(`${ENDPOINT.PATIENT}/${updateFormValues.id}`, formData);
    }
    reset();

  }
  // console.log("!!errors", errors)
  // console.log("!!errors", Object.keys(errors).length === 0)
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };

    const handleLoad = () => {
      const navigationEntry = window.performance.getEntriesByType("navigation")[0];
      if (navigationEntry && navigationEntry.type === 'reload') {
        navigate('/patient-list');
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('load', handleLoad);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  useEffect(() => {
    if (updateResponse.success) {
      showToast("success", "Patient Updated Successfully")
      setTimeout(() => navigate("/patient-list", { replace: true }), 1500)
    }
    if (updateError) {
      showToast("error", updateError.data.error)
    }
  }, [updateResponse, updateError])

  // 

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <InputLabel sx={{ fontSize: "1.5rem" }}>Update Patient Details</InputLabel>
      <FormContainer>
        <InputController
          name="patient_first_name"
          label="Patient First Name"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="patient_middle_name"
          label="Patient Middle Name"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="patient_last_name"
          label="Patient Last Name"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <DatePickerController
          name="dob"
          label="Date of Birth"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <SelectController
          name="sex"
          label="Sex"
          control={control}
          options={gender_options}
          isLoading={updateLoading}
          errors={errors}
        />

        <SelectController
          name="ethnicity"
          label="Ethnicity"
          control={control}
          options={ethnicity_options}
          isLoading={updateLoading}
          errors={errors}
        />

        <SelectController
          name="marital_status"
          label="Marital Status"
          control={control}
          options={marital_status_options}
          isLoading={updateLoading}
          errors={errors}
        />

        <SelectController
          name="education_level"
          label="Education Level"
          control={control}
          options={education_level_options}
          isLoading={updateLoading}
          errors={errors}
        />

        <SelectController
          name="occupation"
          label="Occupation"
          control={control}
          options={occupation_options}
          isLoading={updateLoading}
          errors={errors}
        />

        <SelectController
          name="country_of_origin"
          label="Country of Origin"
          control={control}
          options={country_of_origin_options}
          isLoading={updateLoading}
          errors={errors}
        />

        <SelectController
          name="client_is_handicapped"
          label="Is Handicapped"
          control={control}
          options={client_is_handicapped_options}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="disability"
          label="Disability"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="permanent_residential_address"
          label="Permanent Residential Address"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <SelectController
          name="inkhundla"
          label="Inkhundla"
          control={control}
          options={inkhulda_options}
          isLoading={updateLoading}
          errors={errors}
        />
        {checkChiefdom &&
        <SelectController
          name="chiefdom"
          label="Chiefdom"
          control={control}
          options={chiefdom_options[selectedInkhundla]}
          isLoading={updateLoading}
          errors={errors}
        />}


        <InputController
          name="current_residential_address"
          label="Current Residential Address"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="postal_address"
          label="Postal Address"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="primary_cellphone"
          label="Primary Cellphone"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="secondary_cellphone"
          label="Secondary Cellphone"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="land_phone"
          label="Land Phone"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="patient_email_id"
          label="Patient Email ID"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="national_id"
          label="National ID"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <SelectController
          name="patient_region"
          label="Patient Region"
          control={control}
          options={patient_regions_options}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="CMIS_id"
          label="CMIS ID"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="patient_code"
          label="Patient Code"
          control={control}
          isLoading={updateLoading}
          errors={errors}
          isDisabled={true}
        />

        <InputController
          name="question1"
          label="In which region is your home town?"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="question2"
          label="What is the name of the town where you were born?"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="question3"
          label="What is your mother's maiden name?"
          control={control}
          isLoading={updateLoading}
          errors={errors}
        />

        <InputController
          name="nurse_id"
          label="Nurse ID"
          control={control}
          isLoading={updateLoading}
          errors={errors}
          isDisabled={true}
        />

        <InputController
          name="nurse_name"
          label="Nurse Name"
          control={control}
          isLoading={updateLoading}
          errors={errors}
          isDisabled={true}
        />

        <InputController
          name="year"
          label="Year"
          control={control}
          isLoading={updateLoading}
          errors={errors}
          isDisabled={true}

        />


      </FormContainer>
      <SubmitWrapper>
        <Button type="submit" variant="contained"
          sx={{ minWidth: "180px" }}
          disabled={!isValid || (updateLoading)}>{updateLoading ? <CustomApiLoader /> : isUpdate ? "Update" : "Add"}</Button>
        <Button type="button" variant="contained" onClick={() => reset()}
          sx={{ minWidth: "180px" }} disabled={updateLoading || isUpdate || !Object.keys(errors).length === 0}>Reset</Button>
      </SubmitWrapper>
      {toast && <CustomToast
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </form>
  )
}

export default PateintDetailUpdate